import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: 'hi',
    highlight: false,
}

export const mbSelectSlice = createSlice({
    name: 'selector',
    initialState,
    reducers:{
        selectBorder: (state, action) =>{
            state.value = action.payload
            state.highlight = true
        },
        deselectBorder: (state) =>{
            state.value = ''
            state.highlight = false
        }
    }
})

export const { selectBorder, deselectBorder} = mbSelectSlice.actions

export default mbSelectSlice.reducer